import { render, staticRenderFns } from "./NfcFileManager.vue?vue&type=template&id=07194822&scoped=true"
import script from "./NfcFileManager.vue?vue&type=script&lang=js"
export * from "./NfcFileManager.vue?vue&type=script&lang=js"
import style0 from "./NfcFileManager.vue?vue&type=style&index=0&id=07194822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07194822",
  null
  
)

export default component.exports